import { render, staticRenderFns } from "./MiniviewsBanner.vue?vue&type=template&id=b64938a6"
import script from "./MiniviewsBanner.vue?vue&type=script&lang=js"
export * from "./MiniviewsBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports